export default function powerRange(word, value) {
  const item = this.nextItems(1);

  if (item[0].includes("ft")) {
    item.remove();
  }

  this.parsed.powerRange = parseFloat(value);
}
